import { Option } from "./types";

const stringToOption = (value: string) => {
    return {
        label: value,
        value
    };
}

export const stringsToOptions = (value: string[]) => {
    return value.map((x) => stringToOption(x));
}

export const enumToOptions = (enumType: Record<string, string>) => {
    const values = Object.values(enumType);
    const keys = Object.keys(enumType);

    function getOption(key: string, index: number): Option {
        return {
            label: values[index],
            value: key.toString()
        }
    }

    return keys.map(getOption);
}

//https://codesandbox.io/embed/react-hook-form-validate-email-jr7cu?file=/src/index.js:670-682
export const isValidEmail = (email: string) => {
    // eslint-disable-next-line no-useless-escape
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

export default { stringToOption, enumToOptions, isValidEmail };